import { store } from 'store.js';
import axios from 'axios';
import { API_URL } from 'config.js';
import { caricamento, aggiornaDocumenti } from 'features/99/documenti/documentiSlice';

const API_DOCUMENTI_URL = `${API_URL}/99/get_documenti/`;
const API_FILE_URL = `${API_URL}/generals/get_file/`;

export const getDocName = (documento, anno) => {
  const codice = documento.substring(0, 2); // es. BC
  const serie = `0${documento.charAt(2)}`; // es. 01
  const numero = `000000${documento.split('/')[1]}`.slice(-6); // es. 002699

  return `${anno}-${codice}-${serie}-${numero}`;
};

const b64toBlob = (b64Data, contentType = 'application/pdf', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export async function richiediDati() {
  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  const res = await axios.post(API_DOCUMENTI_URL, { utente, pin });

  const {
    data: { successo, documenti = [] },
  } = res;
  if (successo) {
    store.dispatch(aggiornaDocumenti(documenti ?? []));
  } else {
    store.dispatch(aggiornaDocumenti([]));
  }

  store.dispatch(caricamento(false));
}

export const getFile = async (documento, anno) => {
  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();
  store.dispatch(caricamento(true));
  const res = await axios.post(API_FILE_URL, { utente, pin, idContratto: 0, documento: getDocName(documento, anno) });
  store.dispatch(caricamento(false));
  const { successo } = res.data;

  if (!successo) {
    const { errore } = res.data;
    alert(errore);
    return;
  }

  const { file } = res.data; // YEY abbiamo il nostro file base64
  const fileBlob = b64toBlob(file);
  const fileUrl = URL.createObjectURL(fileBlob);

  window.open(fileUrl, '_blank');
};
